import React from "react";

const defaultSustainabilityRiskAssessData = [
  {
    sno: 1,
    sustainabilityRelatedRiskSR: "",
    timeHorizonSMLSR: "",
    qualitativeAssessmentSR: "",
    quantitativeAssessmentSR: "",
    assessmentMethodSR: "",
  },
];

const SustainabilityRiskAssessmentTable = ({
  sustainabilityRiskAssessData,
  setSustainabilityRiskAssessData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...sustainabilityRiskAssessData];
    updated[index][field] = value;
    setSustainabilityRiskAssessData(updated);
  };
  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));

  const addRow = () =>
    setSustainabilityRiskAssessData([
      ...sustainabilityRiskAssessData,
      {
        sno: (sustainabilityRiskAssessData?.length || 0) + 1,
        sustainabilityRelatedRiskSR: "",
        timeHorizonSMLSR: "",
        qualitativeAssessmentSR: "",
        quantitativeAssessmentSR: "",
        assessmentMethodSR: "",
      },
    ]);

  const removeRow = () => {
    if (sustainabilityRiskAssessData.length > 1) {
      setSustainabilityRiskAssessData(
        renumberRows(sustainabilityRiskAssessData.slice(0, -1))
      );
    }
  };

  // remove per-cell borders; outer frame + inner grid will handle corners
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textAreaStyle = {
    ...inputStyle,
    minHeight: "70px",
    resize: "vertical",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* table frame + perfect corners */}
      <style>{`
        .sraTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;
        }
        .sraTable{
          width: 100%;
          border-collapse: collapse;
        }
        .sraTable th,
        .sraTable td{
          border: 1px solid #000; /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .sraTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide only the outer edges; the frame draws the outside border */
        .sraTable thead tr:first-child th{ border-top: 0; }
        .sraTable tr th:first-child,
        .sraTable tr td:first-child{ border-left: 0; }
        .sraTable tr th:last-child,
        .sraTable tr td:last-child{ border-right: 0; }
        .sraTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="sraTableFrame">
        <table className="sraTable">
          <thead>
            <tr>
              <th style={{ ...header, width: 70 }}>S.No.</th>
              <th style={header}>Sustainability-Related Risk</th>
              <th style={header}>Time Horizon (Short / Medium / Long)</th>
              <th style={header}>Qualitative Assessment</th>
              <th style={header}>
                Quantitative Assessment (Single value or range, if available)
              </th>
              <th style={header}>How the Assessment Was Carried Out?</th>
            </tr>
          </thead>

          <tbody>
            {sustainabilityRiskAssessData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{row.sno || index + 1}.</td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.sustainabilityRelatedRiskSR}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "sustainabilityRelatedRiskSR",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <select
                    value={row.timeHorizonSMLSR}
                    onChange={(e) =>
                      handleChange(index, "timeHorizonSMLSR", e.target.value)
                    }
                    style={inputStyle}
                  >
                    <option value="">Select</option>
                    <option value="Short">Short</option>
                    <option value="Medium">Medium</option>
                    <option value="Long">Long</option>
                  </select>
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.qualitativeAssessmentSR}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "qualitativeAssessmentSR",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.quantitativeAssessmentSR}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "quantitativeAssessmentSR",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.assessmentMethodSR}
                    onChange={(e) =>
                      handleChange(index, "assessmentMethodSR", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default SustainabilityRiskAssessmentTable;
